import { UserStatus } from '@synergy/models';

const translationObject: { [Key in UserStatus]: string } = {
    [UserStatus.ShopAdmin]: 'app.user.status.shopAdmin',
    [UserStatus.ShopUser]: 'app.user.status.shopUser',
    [UserStatus.NoUser]: 'app.user.status.noUser',
    [UserStatus.Locked]: 'app.user.status.locked',
    [UserStatus.NotActivated]: 'app.user.status.notActivated',
    [UserStatus.SupplierAdmin]: '',
    [UserStatus.SupplierUser]: '',
};

export const getUserStatusTranslationId = (userStatus: UserStatus): string => {
    return translationObject[userStatus];
};
